

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 代理店(送り出し)管理
              <div class="card-header-actions">
              </div>
            </CCardHeader>
            <CCardBody>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :fields="fields"
                itemsPerPage="30"
                pagination
              >
                <template #name="{item}">
                  <td>
                     {{ item.name }}
                  </td>
                </template>
                <template #role="{item}">
                  <td> {{formatRole(item.role)}}</td>
                </template>
                <template #contract_start="{item}">
                  <td> {{formatDate(item.contract_start)}}</td>
                </template>
                <template #contract_end="{item}">
                  <td> {{formatDate(item.contract_end)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <div v-if='item.id != 1'>
                      <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                      <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                    </div>

                  </td>
                </template>

              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">会社名</label>
           <CInput
             placeholder="例) 株式会社○○○"
             v-model="record.company_name"
             :class="{ 'hasError': $v.record.company_name.$error }"
             required
           />
           <small v-if="$v.record.company_name.$error" class="errorLabel">会社名を入れてください</small>
         </CCol>
       </CRow>
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label">アカウント名</label>
           <CInput
             placeholder="日本 太郎"
             rows="5"
             :class="{ 'hasError': $v.record.name.$error }"
             v-model="record.name"
           />
           <small v-if="$v.record.name.$error" class="errorLabel">アカウント名を入れてください</small>
         </CCol>
       </CRow>

       <CRow class="form-box" v-if='this.mode != "Edit"'>
         <CCol sm="12">
           <label class="record-label">パスワード</label><br>
           <CInput
             rows="5"
             type='password'
             v-model="record.password"
           />
           <small v-if='iserrorPass' class="errorLabel">パスワードを入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label">確認用パスワード</label>
           <CInput
             rows="5"
             type='password'
             :class="{ 'hasError': notConfirm }"
             v-model="record.confirm"
           />
           <small v-if="notConfirm" class="errorLabel">パスワードが一致しません</small>
         </CCol>
       </CRow>

       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">電話番号</label>
           <CInput placeholder="000-0000-00000" v-model="record.phone" :class="{ 'hasError': $v.record.phone.$error }"/>
           <small v-if="$v.record.phone.$error" class="errorLabel">電話番号を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">メールアドレス</label><br>
           <label class="record-label" v-if='this.mode == "Edit"'>メールアドレスは変更できません</label>
           <CInput placeholder="○○○○○○@example.com" v-model="record.email" :class="{ 'hasError': $v.record.email.$error }"/>
           <small v-if="$v.record.email.$error" class="errorLabel">メールアドレスを入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">ライセンス数</label>
           <CInput type='number' v-model="record.license_count"/>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">役職</label>
           <CInput placeholder="役職" v-model="record.grade"  :class="{ 'hasError': $v.record.grade.$error }" />
           <small v-if="$v.record.grade.$error" class="errorLabel">役職を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">権限</label>
           <CSelect
              label="権限"
              :options="roleOption"
              v-model="record.role"
              name="state"
            />
           <small v-if="$v.record.grade.$error" class="errorLabel">役職を入れてください</small>
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">契約開始日</label>
           <CInput type='date' v-model="record.contract_start"  :class="{ 'hasError': $v.record.contract_start.$error }" />
           <small v-if="$v.record.contract_start.$error" class="errorLabel">契約開始日を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">契約終了日</label>
           <CInput type='date' v-model="record.contract_end"  :class="{ 'hasError': $v.record.contract_end.$error }" />
           <small v-if="$v.record.contract_end.$error" class="errorLabel">契約終了日を入れてください</small>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>

          <small v-if="$v.record.$error" class="errorLabel">無効な値があります</small>

       </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { required, email } from "vuelidate/lib/validators";

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'id', label: ""},
        { key: 'name', label: "代理店名"},
        { key: 'url', label: "URL"},
        { key: 'license_count', label: "ライセンス数"},
        { key: 'user_count', label: "ユーザー数"},
        { key: 'invitation_code', label: "招待コード"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      recordModal: false,
      deleteModal: false,
      notConfirm: false,
      iserrorPass: false,
      mode: "",
      confirm: '',
      password: '',
      itemIndex: 0,
      meta: {},
      record: {
        name: "",
        description: ""
      },
      roleOption: [
        '',
        '管理者',
        'パートナー'
      ]
    }
  },
  validations: {
    record: {
      name: {required},
      company_name: {required},
      phone: {required},
      email: {required, email},
      grade: {required},
      contract_start: {required},
      contract_end: {required}
    }
  },
  methods: {
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          console.log(result)
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/partners?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            console.log(response.data.industries)
            this.items = response.data.industries
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    formatRole(role){
      if(role == 'admin'){
        return '管理者'
      }else{
        return 'パートナー'
      }
    },
    formatDate: function(d) {
      return moment(d).format("YYYY/MM/DD")
    },
    validator (val) {
      return val ? val.length >= 1 : false
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規業種追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      if(mode == 'Edit'){
        i.role = this.formatRole(i.role)
        i.contract_start = moment(i.contract_start).format("YYYY-MM-DD")
        i.contract_end = moment(i.contract_end).format("YYYY-MM-DD")
      }
      this.record = i

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    updateItem: function(mode="Create", index=0) {
      this.$v.record.$touch();
      if(this.record.password == ''){
        this.iserrorPass = true
        return
      }
      if(this.record.password != this.record.confirm){
        this.notConfirm = true
        return
      }
      if(this.$v.record.$error) return
      if(this.record.role == '管理者'){
        this.record.role = 'admin'
      }else{
        this.record.role = 'partner'
      }
      console.log(mode)
      if(mode == "Create") {
        var d = Math.random().toString(32).substring(2)
        this.record['invitation_code'] = d

        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/partners", {"partner": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.push(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/partner/" + this.record.id, {"partner": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.recordModal = false
            this.items[index] = this.record
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/partner/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.items.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/agencies", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          console.log(response.data)
          this.items = response.data.agencies
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
      partner:'GetPartner',
    })
  },
}
</script>
